import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
  size?: 'md' | 'lg';
};
const sizes = {
  md: 'px-5 py-3 text-sm',
  lg: 'px-6 py-4 text-sm md:px-10 md:py-5 md:text-lg'
};
export function Button({
  children,
  href,
  subtext,
  className = '',
  fullWidth,
  size = 'md'
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex flex-col items-center justify-center rounded-xl border-2 border-b-[6px] border-amber-600 bg-amber-400 text-center font-black uppercase tracking-wide text-teal-950 shadow-xl shadow-teal-950/30 transition-colors duration-150 ease-out hover:bg-amber-300 focus:outline-none focus:ring-4 focus:ring-amber-300/70 ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-265" data-mp="1sizticizjs81">
      <span className="flex items-center gap-2" data-id="element-266" data-mp="er7efk9uls8j">
        {children}
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-267" data-mp="tn6w9mmrf6qv" />
      </span>
      {subtext && <span className="mt-1 text-[11px] font-semibold normal-case tracking-normal text-teal-950/85 md:text-xs" data-id="element-268" data-mp="omslvxxorkpo">
          {subtext}
        </span>}
    </motion.a>;
}